import { Church } from "lucide-react";
import { getChurches } from "@/lib/api";

const churchesProvider = {
  id: "iglesias",
  label: "Iglesias",
  icon: Church,
  iconBg: "bg-sky-50",
  iconColor: "text-sky-600",
  fields: ["name", "address"],
  load: (districtId) => getChurches(districtId),
  buildItem: (c) => ({
    id: c.id,
    title: c.name,
    subtitle: c.address || "Iglesia",
    route: `/churches/${c.id}`,
    recent: { id: c.id, type: "church", title: c.name, subtitle: c.address || "Iglesia", route: `/churches/${c.id}` },
  }),
};

export default churchesProvider;
